import React from 'react'

function EditMovementsOfMeeting() {
  return (
    <div>
      
    </div>
  )
}

export default EditMovementsOfMeeting;
